<style src="./ContextSelectAssociated.scss" lang="scss"></style>
<template>
  <section class="context-select-associated">
    <button
      type="button"
      @click="openModal"
      class="cp1-small-button cp1-button__warning">
      Escolher Associados
    </button>

    <modal
      transition="nice-modal-fade"
      name="modalAutoSetAssociated"
      width="500px"
      height="auto">
      <aside class="context-modal-confirm">
        <icon-danger class="illustration" />
        <span class="description">
          Essa ação irá escolher automaticamente todas as associações feitas aos itens.
        </span>

        <form
          @submit.prevent="applyAssociated"
          class="form-modal">
          <button
            type="button"
            @click="cancelApply"
            class="btn-ghost">Cancelar ação</button>

          <button-submit
            label="Sim, escolha automaticamente"
            :state="commands.submitState"
            :icon-save="commands.saveIcon" />
        </form>
      </aside>
    </modal>
  </section>
</template>

<script>
import { ButtonSubmit } from '@/components/primitives'
import { IconRightArrow, IconDanger, IconSave } from '@/components/primitives/icons'
import MapToChoice from '../../helpers/MapToChoice'
import DefineLowestMaxPrice from '@/brain/item-pricing/define-lowest-max-price'

export default {
  name: 'ContextSelectAssociated',
  components: {
    ButtonSubmit,
    IconRightArrow,
    IconDanger,
    IconSave
  },
  data: () => ({
    addPercentual: 20,
    commands: {
      submitState: 'REPOSE',
      saveIcon: IconSave
    }
  }),
  methods: {
    cancelApply () {
      this.$modal.hide('modalAutoSetAssociated')
    },
    openModal () {
      this.$modal.show('modalAutoSetAssociated')
    },
    async applyAssociated () {
      this.commands.submitState = 'WAIT'

      const mapWithMargin = MapToChoice(this.$store.getters['ItemPricing/PROPOSAL_MARGIN'], this.$store.getters['ItemPricing/DECIMAL_PRECISION'])
      const filteredItems = this.$store.getters['ItemPricing/GET_ALL_LIST']
        .filter(i => i.associated && i.associated.isAssociated)

      const payload = filteredItems.map(mapWithMargin)
      for (const item of filteredItems) {
        const proposalPrice = (item.associated.price * ((this.$store.getters['ItemPricing/PROPOSAL_MARGIN'] / 100) + 1)).toFixed(this.$store.getters['ItemPricing/DECIMAL_PRECISION'])
        const proposalTotalPrice = proposalPrice * item.itemInfo.quantity * item.itemInfo.factor
        const proposalPerc = (((proposalPrice * 100) / item.associated.price) - 100).toFixed()

        // Get the lowest value between Cmed and estimated as long as it's not zero
        const lowerValue = DefineLowestMaxPrice(item.associated.cmedPrice, item.itemInfo.estimatedPrice)

        // Check if proposal is higher than max price
        const isHigherThanMax = proposalPrice > lowerValue
        const info = {
          quoted: {
            cmedLab: item.associated.cmedLab,
            cmedPrice: item.associated.cmedPrice,
            cmedTotalPrice: item.associated.cmedPrice * item.itemInfo.quantity * item.itemInfo.factor,
            cmedPerc: (((item.associated.cmedPrice * 100) / item.associated.price) - 100).toFixed(),
            isPriceGuaranted: false,
            isQuoted: true,
            itemId: item.associated.itemId,
            lab: item.associated.lab,
            price: item.associated.price,
            priceTotal: item.associated.price * item.itemInfo.quantity * item.itemInfo.factor,
            proposalPrice,
            proposalTotalPrice,
            proposalPerc,
            minimumPrice: proposalPrice,
            minimumTotalPrice: proposalTotalPrice,
            minimumPerc: proposalPerc,
            proposalIsHigherThanMaxprice: isHigherThanMax,
            minimumIsHigherThanMaxprice: isHigherThanMax
          }
        }
        this.$store.commit('ItemPricing/SET_ITEM', {
          itemId: item.itemId,
          info
        })
      }

      try {
        await this.$store.dispatch('ItemPricing/AUTO_SET_ASSOCIATED', { payload })
        this.$toasted.success('Atualização salva com sucesso!')
      } catch (error) {
        this.$toasted.error(error)
      } finally {
        this.commands.submitState = 'REPOSE'
        this.$modal.hide('modalAutoSetAssociated')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/context-select-associated/ContextSelectAssociated.vue